// extracted by mini-css-extract-plugin
export default {"fullWidth":"styles_fullWidth__hVhnX"};